import { Icon } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from "react";
import { getProfils } from "../../shared/api/request";
import ProfilVisual from "../components/ProfilVisual";

import HeaderV2 from "../../shared/components/HeaderV2";
import AuthContext from "../../shared/context/TokenContext";
import "../../shared/css/basicStyles.css";
import "../../shared/css/ui.css";
import { Profil } from "../../shared/types/Profil";
import { Receipt } from "../components/SubscriptionCard";
import "../css/User.css";

type AccountInfos = {
  mail: string;
  profils: Profil[];
  clientSecret: string;
  receipt: Receipt;
};

const ProfilSkeleton = () => (
  <div className="pf-page" aria-busy="true" aria-label="Chargement de votre compte">
    <div className="nbk-skeleton" style={{ width: 220, height: 36, marginBottom: 24 }} />
    <div className="pf-grid">
      <div className="pf-column">
        <div className="nbk-skeleton pf-skeleton__card" />
        <div className="nbk-skeleton pf-skeleton__card pf-skeleton__card--tall" />
      </div>
      <div className="pf-column">
        <div className="nbk-skeleton pf-skeleton__card" />
        <div className="nbk-skeleton pf-skeleton__card" />
      </div>
    </div>
  </div>
);

const ProfilScreen = () => {
  const auth = useContext(AuthContext);

  const [infos, setInfos] = useState<AccountInfos | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const fetchInfos = useCallback(async () => {
    const res = await getProfils();
    if (res?.mail !== undefined) {
      setInfos({
        mail: res.mail,
        profils: res.profils ?? [],
        clientSecret: res.clientSecret ?? "",
        receipt: res.receipt ?? {},
      });
      setHasError(false);
    } else setHasError(true);
  }, []);

  const loadInfos = useCallback(async () => {
    setIsLoading(true);
    await fetchInfos();
    setIsLoading(false);
  }, [fetchInfos]);

  useEffect(() => {
    loadInfos();
  }, [loadInfos]);

  return (
    <div className="mainContainer">
      <HeaderV2 selected="profil" type="user" />
      {isLoading ? (
        <ProfilSkeleton />
      ) : hasError || !infos ? (
        <div className="pf-page">
          <div className="pf-state" role="alert">
            <Icon aria-hidden="true">cloud_off</Icon>
            <h1>Impossible de charger votre compte</h1>
            <p>Vérifiez votre connexion internet puis réessayez.</p>
            <button type="button" className="nbk-btn nbk-btn--primary" onClick={loadInfos}>
              <Icon aria-hidden="true">refresh</Icon>
              Réessayer
            </button>
          </div>
        </div>
      ) : (
        <ProfilVisual
          mail={infos.mail}
          profils={infos.profils}
          clientSecret={infos.clientSecret}
          receipt={infos.receipt}
          logout={auth.logout}
          onChanged={fetchInfos}
        />
      )}
    </div>
  );
};

export default ProfilScreen;
